import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
import { mapErrorMessage } from '../utils/maps.js';
const removeBitGetFromErrorString = (message) => message
    .replaceAll('BitGet', '')
    .replaceAll('Bitget:', '')
    .replaceAll('Bitkeep:', '');
export class BitGetException extends ConcreteException {
    static errorClass = 'BitGetException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        const { message } = this;
        if (message
            .trim()
            .toLowerCase()
            .includes('missing or invalid parameters'.toLowerCase())) {
            this.setMessage('Please make sure you are using BitGet Wallet');
        }
        else {
            this.setMessage(mapErrorMessage(removeBitGetFromErrorString(message)));
        }
        this.setName(BitGetException.errorClass);
    }
}
